import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { change, Field, reduxForm, reset } from 'redux-form';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
// import { CancelButton, CommonButton } from '../../../../components/buttons';
import { showFormatedDate, showFormattedTime, resetFiltersAndSorting, BEHAVIOR_BLOSSOMS, AIP, EBS } from '../../../../../../actions/utilAction';
import { renderDateField, renderCheckBox } from '../../../../../../components/reduxFields';
import PaginatorCustom from '../../../../../../components/paginationCustom';
import SortingCustom from '../../../../../../components/SortingCustom';
import { getAppointmentList, saveEncounterWithSignature, saveEncounterWithSignatureAndComplete } from './actions';
import { getGeoLocation } from '../../../../../AppConfig/actions';
import SignatureModal from './signature_modal';
import SignatureAndCompleteModal from './signatureAndComplete_modal';

const stylescss = {
    checkbox: {
        marginBottom: 16,
    },
};

class ManageAppointments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
            ToDate: new Date(),
            responseDataAppointments: [],
            selectedPatientEncounterIds: [],
            openSign: false,
            openSignAndComplete: false,
            ShowSignedSessionsOnly: false,
            ShowSignedSessionsOnlyAfterFilter: false,
        }
        this.manageAppointmentsSubmit = this.manageAppointmentsSubmit.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.setSortColumn = this.setSortColumn.bind(this);
        this.filter = {
            sort_Column: 'dos',
            sort_Order: 'desc',
        };
    }


    componentWillMount = () => {
        this.loadData();
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.manageAppointments !== null) {
            this.setState({ responseDataAppointments: nextProps.manageAppointments });
        }
        else {
            this.setState({ responseDataAppointments: [] });
        }

        // console.log('logs...........',nextProps.signedAppointmentList , this.props.signedAppointmentList)
        if (nextProps.signedAppointmentList !== null && nextProps.signedAppointmentList !== this.props.signedAppointmentList) {
            let appointmentData = this.props.manageAppointments.data !== undefined && this.props.manageAppointments.data;
            appointmentData.forEach((obj, appointmentIndex) => {
                let appointmentIdCheck = `Appointments[${appointmentIndex}].Chk`;
                this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, false));
            });
            this.setState({ selectedPatientEncounterIds: [] }, () => { this.loadData() });
        }

        if (nextProps.signedAndCompleteAppointmentList !== null && nextProps.signedAndCompleteAppointmentList !== this.props.signedAndCompleteAppointmentList) {
            let appointmentData = this.props.manageAppointments.data !== undefined && this.props.manageAppointments.data;
            appointmentData.forEach((obj, appointmentIndex) => {
                let appointmentIdCheck = `Appointments[${appointmentIndex}].Chk`;
                this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, false));
            });
            this.setState({ selectedPatientEncounterIds: [] }, () => { this.loadData() });
        }
        
    }


    onDateChange(input, value) {
        input.onChange(moment(value).format());
        this.setState({ [input.name]: value });
    }

    manageAppointmentsSubmit = (event) => {
        this.setState({
            selectedPatientEncounterIds: [],
            FromDate: event.FromDate ? showFormatedDate(event.FromDate) : new Date(new Date().setDate(new Date().getDate() - 7)),
            ToDate: event.ToDate ? showFormatedDate(event.ToDate) : new Date(),
            ShowSignedSessionsOnlyAfterFilter: this.state.ShowSignedSessionsOnly,
        }, () => {
            this.loadData();
        })
    }

    handleReset = () => {
        this.props.dispatch(reset('ManageAppointmentsForm'));
        resetFiltersAndSorting(this.filter, 'claimid', true);
        this.setState({
            FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
            ToDate: new Date(),
            responseDataAppointments: [],
            selectedPatientEncounterIds: [],
            ShowSignedSessionsOnly: false,
            ShowSignedSessionsOnlyAfterFilter: false,
        }, () => {
            this.loadData();
        })
    }

    checkAllAppointments = (e) => {
        let isAllAppointmentChecked = e.target.checked;
        let appointmentData = this.props.manageAppointments != null && this.props.manageAppointments.data !== undefined && this.props.manageAppointments.data;
        let selectedPatientEncounterIds = [];
        appointmentData != null && appointmentData.forEach((obj, appointmentIndex) => {
            let appointmentIdCheck = `Appointments[${appointmentIndex}].Chk`;
            if (obj && isAllAppointmentChecked && obj.isBillableEncounter) {
                selectedPatientEncounterIds.push(obj.patientEncounterId);
                this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, true));
            } else if (obj && isAllAppointmentChecked && !obj.isBillableEncounter) {
                selectedPatientEncounterIds.push(obj.patientEncounterId);
                this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, true));
            } else {
                this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, false));
            }
        });
        this.setState({ selectedPatientEncounterIds: selectedPatientEncounterIds });
    }


    checkAppointments = (e, index, data) => {
        let selectedPatientEncounterIds = this.state.selectedPatientEncounterIds;
        let isAppointmentChecked = e.target.checked;
        if (isAppointmentChecked) {
            if (data.patientEncounterId && data.isBillableEncounter) {
                selectedPatientEncounterIds.push(data.patientEncounterId);
            } else {
                selectedPatientEncounterIds.push(data.patientEncounterId);
            }
        }
        else {
            index = selectedPatientEncounterIds.findIndex((value) => value === data.patientEncounterId);
            if (index >= 0) {
                selectedPatientEncounterIds.splice(index, 1);
            }
        }

        this.setState({ selectedPatientEncounterIds: selectedPatientEncounterIds });
    }


    loadData = (page_number) => {
        let searchObj = {
            sortColumn: this.filter.sort_Column ? this.filter.sort_Column : 'dos',
            sortOrder: this.filter.sort_Order ? this.filter.sort_Order : 'desc',
            contain_filters: {
                patientId: this.props.patientId,
                fromDate: this.state.FromDate ? moment(this.state.FromDate).format('YYYY-MM-DD') : new Date(new Date().setDate(new Date().getDate() - 7)),
                toDate: this.state.ToDate ? moment(this.state.ToDate).format('YYYY-MM-DD') : new Date(),
                showSignedSessionsOnly: this.state.ShowSignedSessionsOnly ? '1' : '0',
            },
            pageNumber: page_number ? page_number : 1,
            pageSize: 100,
        };
        // console.log('searchObj........',searchObj)
        this.props.getAppointmentList(searchObj);
    }

    setSortColumn(col_name, col_order) {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_Order = col_order;
            this.loadData();
        }
    }

    handleCloseSign = () => {
        this.setState({ openSign: false, openSignAndComplete: false });
    };

    handleOpenSign = () => {
        this.props.getGeoLocation();
        this.setState({ openSign: true, openSignAndComplete: false, soapPage: true });
    };

    handleOpenSignAndComplete = () => {
        this.props.getGeoLocation();
        this.setState({ openSign: false, openSignAndComplete: true, soapPage: true });
    };

    handleAddSign = (formProps) => {
        let signBytes = formProps.signBytes.substring(22);
        let postData = {
            //id : null,
            patientEncounterIds: this.state.selectedPatientEncounterIds.toString(),
            guardianSign: signBytes,
            guardianSignDate: moment.utc().format('YYYY-MM-DDTHH:mm:ss'),
            guardianName: formProps.Guardian || '',
            latitude: this.props.latitude || 0.0,
            longitude: this.props.longitude || 0.0
        };

        // console.log('postData............',postData)
        this.props.saveEncounterWithSignature(postData);
    }

    handleAddSignAndComplete = (formProps) => {
        let signBytes = formProps.signBytes.substring(22);
        let postData = {
            //id : null,
            patientEncounterIds: this.state.selectedPatientEncounterIds.toString(),
            guardianSign: signBytes,
            guardianSignDate: moment.utc().format('YYYY-MM-DDTHH:mm:ss'),
            guardianName: formProps.Guardian || '',
            latitude: this.props.latitude || 0.0,
            longitude: this.props.longitude || 0.0
        };

        // console.log('postData............',postData)
        this.props.saveEncounterWithSignatureAndComplete(postData);
    }

    handleAdvanceFilterCheck = (input, name) => {
        this.setState({ [name]: input.target.checked });
    }

    render() {
        const { handleSubmit } = this.props;
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.bordered,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'maintable': true,
            'customtable': true,
        });
        const tableClass1 = classNames({
            'table': true,
            'middletable': true,
            'customtable': true,
        });
        return (
            <div>
                {this.state.openSign ?
                    <SignatureModal closeDialog={this.handleCloseSign} handleAddSign={this.handleAddSign.bind(this)} />
                    : null}
                {this.state.openSignAndComplete ?
                    <SignatureAndCompleteModal closeDialog={this.handleCloseSign} handleAddSignAndComplete={this.handleAddSignAndComplete.bind(this)} />
                    : null}
                <h2 className="page_title">Bulk Signatures</h2>
                <div className="clearfix" />
                <div className="readmin-panel">
                    <div className="panel-body">
                        <form className="readmin-form custom_form" onSubmit={handleSubmit(this.manageAppointmentsSubmit)}>
                            <div className='row'>
                                <div className="col-sm-2">
                                    <Field name="FromDate"
                                        placeholder="From Date"
                                        locale="en-US"
                                        selected={this.state.FromDate}
                                        onDateChange={this.onDateChange}
                                        openToYearSelection={true}
                                        component={renderDateField} />

                                </div>
                                <div className="col-sm-2">
                                    <Field name="ToDate"
                                        placeholder="To Date"
                                        locale="en-US"
                                        minDate={this.state.FromDate}
                                        selected={this.state.ToDate}
                                        openToYearSelection={true}
                                        onDateChange={this.onDateChange}
                                        component={renderDateField} />
                                </div>
                                <div className="col-sm-3 mt-20">
                                    <Field
                                        name="ShowSignedSessionsOnly"
                                        label="Show Signed / Rendered Sessions Only"
                                        component={renderCheckBox}
                                        onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowSignedSessionsOnly')}
                                    />
                                </div>
                                <div className="col-2 col-sm-2 col-md-2 btn_rt reset-btn claims_filter mt-20">
                                    <RaisedButton className="grey_btn" type="Submit" primary={true} >Filter</RaisedButton>
                                    <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-12 col-sm-12 col-md-12 reset-btn claims_filter mt-20">
                                    {/* <RaisedButton className={this.state.selectedPatientEncounterIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} disabled={this.state.selectedPatientEncounterIds.length > 0 ? false : true} onTouchTap={(e) => this.handleSubmitAppointments(e)} >RENDER APPOINTMENTS</RaisedButton> */}
                                    <RaisedButton className={(this.state.ShowSignedSessionsOnlyAfterFilter && this.state.selectedPatientEncounterIds.length > 0) ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} disabled={(this.state.ShowSignedSessionsOnlyAfterFilter && this.state.selectedPatientEncounterIds.length > 0) ? false : true} primary={true} onTouchTap={this.handleOpenSign} >Add Sign</RaisedButton>
                                    <RaisedButton className={(!this.state.ShowSignedSessionsOnlyAfterFilter && this.state.selectedPatientEncounterIds.length > 0) ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} disabled={(!this.state.ShowSignedSessionsOnlyAfterFilter && this.state.selectedPatientEncounterIds.length > 0) ? false : true} primary={true} onTouchTap={this.handleOpenSignAndComplete} >Add Sign and Complete</RaisedButton>
                                </div>
                            </div>
                        </form>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="table-responsive mt-15">
                                    <table className={tableClass}>
                                        <thead>
                                            <tr>
                                                <th width="10%">
                                                    {this.props.agencyName.toUpperCase() === BEHAVIOR_BLOSSOMS || this.props.agencyName.toUpperCase() === AIP || this.props.agencyName.toUpperCase().startsWith(EBS) ?
                                                        <div className="table_custom-check"></div> :
                                                        <div className="table_custom-check">
                                                            <Field
                                                                name='chkAppointment'
                                                                component={renderCheckBox}
                                                                onChange={(e) => this.checkAllAppointments(e)}
                                                                style={stylescss.checkbox}
                                                            />
                                                            <span>&nbsp;</span>
                                                        </div>
                                                    }
                                                </th>
                                                <th width="30%"><SortingCustom setSortColumn={this.setSortColumn} columnName='dos' displayName='Date Of Service' /></th>
                                                {/* <th width="25%">Client Name</th> */}
                                                <th width="30%">Practitioner Name</th>
                                                <th width="30%">Appointment Type</th>
                                                {/* <th width="15%">Billable Service</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.responseDataAppointments && this.state.responseDataAppointments.data && this.state.responseDataAppointments.data.length > 0 ?
                                                this.state.responseDataAppointments.data.map((data, index) => {
                                                    return (
                                                        <tr key={data.patientEncounterId}>
                                                            <td colSpan="4">
                                                                <table className={tableClass1}>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width="10%">
                                                                                <div className="table_custom-check">
                                                                                    {this.props.agencyName.toUpperCase() === BEHAVIOR_BLOSSOMS || this.props.agencyName.toUpperCase() === AIP || this.props.agencyName.toUpperCase().startsWith(EBS) ?
                                                                                        <Field
                                                                                            name={`Appointments[${index}].Chk`}
                                                                                            component={renderCheckBox}
                                                                                            onChange={(e) => this.checkAppointments(e, index, data)}
                                                                                            disabled={data.isServiceTimeOver ? false : true}
                                                                                            style={stylescss.checkbox}
                                                                                        />
                                                                                        :
                                                                                        <Field
                                                                                            name={`Appointments[${index}].Chk`}
                                                                                            component={renderCheckBox}
                                                                                            onChange={(e) => this.checkAppointments(e, index, data)}
                                                                                            style={stylescss.checkbox}
                                                                                        />
                                                                                    }
                                                                                </div>
                                                                            </td>
                                                                            <td width="30%">{showFormatedDate(data.startDateTime)}{' (' + showFormattedTime(data.startDateTime) + ' - ' + showFormattedTime(data.endDateTime) + ')'}</td>
                                                                            {/* <td width="25%">{data.patientName ? data.patientName : 'N/A'}</td> */}
                                                                            <td width="30%">{data.staffName}</td>
                                                                            <td width="30%">{data.appointmentTypeName}</td>
                                                                            {/* <td width="15%"  className={data.isBillableEncounter === true ? 'greenfont' : 'redfont'}>{data.isBillableEncounter === true ? "Yes" : "No"}</td> */}
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>

                                                    )
                                                })
                                                :
                                                <tr>
                                                    <td colSpan="4">
                                                        <div className="familydl text-center no-record">No record found.</div>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                {this.state.responseDataAppointments && this.state.responseDataAppointments.data && this.state.responseDataAppointments.data.length ?
                                    <PaginatorCustom data={this.state.responseDataAppointments.meta} handlePageChange={(pageNumber) => this.loadData(pageNumber)} />
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ManageAppointments = reduxForm({
    form: 'ManageAppointmentsForm',
})(ManageAppointments);

function mapStateToProps(state) {
    let patientId;
    if (state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.roleName === 'Client') {
        patientId = state.login.loginUserInfo.id;
    } else {
        patientId = state.patient.patientId;
    }

    return {
        manageAppointments: state.patient_manageAppointments.appointmentList,
        signedAppointmentList: state.patient_manageAppointments.signed_appointmentList,
        signedAndCompleteAppointmentList: state.patient_manageAppointments.signedAndComplete_appointmentList,
        patientId: patientId,
        latitude: state.appConfig.latitude,
        longitude: state.appConfig.longitude,
        agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    }
}

export default connect(mapStateToProps, { getAppointmentList, saveEncounterWithSignature, saveEncounterWithSignatureAndComplete, getGeoLocation })(ManageAppointments)



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/ManageAppointments/components/appointments/index.js